module.exports = __webpack_public_path__ + "62c93f5bf60a98bf626ee617ca585140.png";